import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
/**
 * Selects live voting session
 * @param  {Number} eventId         Event ID
 * @return {Object}                 Voting session data
 */

export function useLiveVotingSessions(eventId, { filter } = {}) {
    const selectVotingSessions = useCallback((state) => state.events[eventId]?.voting.sessions, [eventId]),
        votingSessions = useSelector(selectVotingSessions);

    return useMemo(() => {
        let result = votingSessions ?? [];

        if (filter)
            result = result.filter(filter);

        return result;
    }, [votingSessions, filter]);
}
